<template>
	<div>
 <div  :class="getColorClass(event.tid, event.parents_id)" class="bg" @click="toggleClick"  v-on-clickaway="away">

     <div class="title">{{event.longtitle}}</div>


	 <div class="time" v-if='showTime'>{{event.datetime}}</div>

</div>

 	<EventHover :event="event" v-if='isClicked'></EventHover>
 </div>
</template>


<script>

	import store  from './CalendarStoreEvents'
	import EventHover from './EventHover'
	import { directive as onClickaway } from 'vue-clickaway';

	
	export default {
	  	
	  	name: 'one-event',
	  	props: ['event', 'showTime', 'longTitle'], 
	  	components : {EventHover},
	  	
	  	data () {
		    return {
		    
		    	isClicked: false
		    }
		}, 
		  directives: {
		    onClickaway: onClickaway,
		  },
  		  mounted () {
		    // prevent click outside event with popupItem.
		    this.popupItem = this.$el
		  },
			methods : {

			toggleClick(){
				this.$emit('eventchild', true)
				this.isClicked = true

			}, 
			away(){
				this.isClicked = false
			},
			getColorClass(tid, parentTid){
				return store.getColorClass(tid, parentTid)
			}

		

		}
		
	}

</script>


// WEBPACK FOOTER //
// OneEvent.vue?1724554c